import {FC} from 'react';

import {useInitialEffect} from '../../libs/shared/helpers/src/react/hooks/useEffectHelpers';
import {registerNavigateToLinkFunction} from '../services/electron/electronBridgeNavigateToLink';
import {useLinkNavigation} from './common/navigation/useLinkNavigation';

/** Allows electronBridge to have access to some UI capabilities without tight coupling. */
export const ElectronUICapabilities: FC = () => {
  const {navigateToLink, maybeRenderLinkError} = useLinkNavigation();

  useInitialEffect(() => {
    registerNavigateToLinkFunction(navigateToLink);
  });

  return maybeRenderLinkError();
};
